export let hres96uColumns = () => {
  let indexColumns = [{
    key: 'codempid',
    name: '',
    labelCodapp: 'HRES96UC1',
    labelIndex: '30',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'desc_codempid',
    name: '',
    labelCodapp: 'HRES96UC1',
    labelIndex: '40',
    style: 'min-width: 200px;'
  }, {
    key: 'dtereq',
    name: '',
    labelCodapp: 'HRES96UC1',
    labelIndex: '50',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'numseq',
    name: '',
    labelCodapp: 'HRES96UC1',
    labelIndex: '60',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'dtechq',
    name: '',
    labelCodapp: 'HRES96UC1',
    labelIndex: '70',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'shfreq',
    name: '',
    labelCodapp: 'HRES96UC1',
    labelIndex: '80',
    class: 'align-center',
    style: 'min-width: 200px;',
    headerRow: 1,
    colspan: 2,
    rowspan: 1
  }, {
    key: 'shfreqo',
    name: '',
    labelCodapp: 'HRES96UC1',
    labelIndex: '90',
    class: 'align-center',
    style: 'min-width: 100px;',
    headerRow: 2,
    colspan: 1,
    rowspan: 1
  }, {
    key: 'shfreqn',
    name: '',
    labelCodapp: 'HRES96UC1',
    labelIndex: '100',
    class: 'align-center',
    style: 'min-width: 100px;',
    headerRow: 2,
    colspan: 1,
    rowspan: 1
  }, {
    key: 'desc_codidchq',
    name: '',
    labelCodapp: 'HRES96UC1',
    labelIndex: '110',
    style: 'min-width: 200px;'
  }, {
    key: 'reason',
    name: '',
    labelCodapp: 'HRES96UC1',
    labelIndex: '120',
    style: 'min-width: 200px;'
  }, {
    key: 'status',
    name: '',
    labelCodapp: 'HRES96UC1',
    labelIndex: '130',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_codappr',
    name: '',
    labelCodapp: 'HRES96UC1',
    labelIndex: '140',
    style: 'min-width: 200px;'
  }, {
    key: 'dteappr',
    name: '',
    labelCodapp: 'HRES96UC1',
    labelIndex: '150',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'remark',
    name: '',
    labelCodapp: 'HRES96UC1',
    labelIndex: '160',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_codempap',
    name: '',
    labelCodapp: 'HRES96UC1',
    labelIndex: '170',
    style: 'min-width: 200px;'
  }]

  return {
    en: {
      index: indexColumns
    },
    th: {
      index: indexColumns
    }
  }
}
export let hres96uMaxRowspan = {
  index: 2
}



// WEBPACK FOOTER //
// ./src/assets/columns/hres96u.js